import ProsperoPostType, { ProsperoPostTypeStrings } from 'enums/ProsperoPostType'
import { countUnicodeLength } from 'utils/unicodeSubstringUtil'
import { Metadata } from '../../adaptor/metadata'
import originalAuthorResolver from '../originalAuthor/originalAuthorResolver'
import postTypeResolver from '../document/postTypeResolver'
import displayTextRangeResolver from './displayTextRangeResolver'
import { removeMetaData } from './retweetsUtil'

const DEFAULT_TRUNCATE_LENGTH = 240

const getMetaDataLength = (
  displayText: string,
  originalAuthor: string,
  postType: ProsperoPostTypeStrings
) => {
  if (postType === ProsperoPostType.TW_RETWEETS) {
    const header = `RT @${originalAuthor}: `
    if (displayText.indexOf(header) === 0) {
      return header.length
    }
  }

  return 0
}

export const getDocumentTruncateIndex = (metadata: Metadata) => {
  const sentences = metadata.getSentences()
  const truncateLength = metadata.getTruncatedLength() || DEFAULT_TRUNCATE_LENGTH
  let totalLength = 0
  let index
  let lastSentenceLimit = -1

  if (!sentences) {
    return { index, lastSentenceLimit }
  }

  for (index = 0; index < sentences!.length; index += 1) {
    const { originalAuthor } = originalAuthorResolver(metadata)
    const { postType } = postTypeResolver(metadata)
    const sentence = sentences![index]!.replace(/\u200B/g, '')

    let sentenceWithoutMeta = removeMetaData(sentence, originalAuthor!, postType!)
    const { displayTextRange } = displayTextRangeResolver(metadata)

    if (displayTextRange && displayTextRange[0] && displayTextRange[0].startOffset! > 0) {
      sentenceWithoutMeta = sentenceWithoutMeta.substring(displayTextRange[0].startOffset!)
    }

    const sentenceLength = countUnicodeLength(sentenceWithoutMeta)
    totalLength += sentenceLength
    // Space between sentence
    const spaceLength = index !== sentences!.length - 1 ? 1 : 0

    totalLength += spaceLength

    if (totalLength >= truncateLength) {
      // CB-26991 minus space between sentence & RT: @XXX
      lastSentenceLimit =
        truncateLength -
        (totalLength - spaceLength - sentenceLength) +
        getMetaDataLength(sentence, originalAuthor!, postType!)

      if (displayTextRange && displayTextRange[0] && displayTextRange[0].startOffset! > 0) {
        lastSentenceLimit += displayTextRange[0].startOffset!
      }

      break
    }
  }

  return { index, lastSentenceLimit }
}

export default getDocumentTruncateIndex
